import angular from 'angular';
import timepicker from 'angular-ui-bootstrap/src/timepicker';
import RwTimepickerComponent from './rw-timepicker-component';

export default angular
  .module('rw-timepicker', [timepicker])
  .component('rwTimepicker', new RwTimepickerComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-timepicker/rw-timepicker-module.js